export const WAEC_DIGITAL_TECH_LEARN_SS1 = [];